/**
* Testimonial JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonial component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'testimonial',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.testimonial-slider__splide' ).length ) {
        $( '.testimonial-slider__splide' ).each( function( index, element ) {
          new Splide( element, {
            type: 'loop',
            gap: '2rem',
            perMove: 1,
            perPage: 1,
            pagination: false,
            speed: 800,
          } ).mount( {} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonial', COMPONENT );
} )( app );
